import React from "react";

export const Sponser = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.14398 8.02875C5.13097 8.02875 5.92197 8.82745 5.92197 9.82144V12.2077C5.92197 13.1947 5.13097 13.9997 4.14398 13.9997H1.77799C0.797996 13.9997 0 13.1947 0 12.2077V9.82144C0 8.82745 0.797996 8.02875 1.77799 8.02875H4.14398ZM12.222 8.02875C13.202 8.02875 14 8.82745 14 9.82144V12.2077C14 13.1947 13.202 13.9997 12.222 13.9997H9.85602C8.86903 13.9997 8.07803 13.1947 8.07803 12.2077V9.82144C8.07803 8.82745 8.86903 8.02875 9.85602 8.02875H12.222ZM4.14398 0C5.13097 0 5.92197 0.804996 5.92197 1.79269V4.17898C5.92197 5.17297 5.13097 5.97097 4.14398 5.97097H1.77799C0.797996 5.97097 0 5.17297 0 4.17898V1.79269C0 0.804996 0.797996 0 1.77799 0H4.14398ZM12.222 0C13.202 0 14 0.804996 14 1.79269V4.17898C14 5.17297 13.202 5.97097 12.222 5.97097H9.85602C8.86903 5.97097 8.07803 5.17297 8.07803 4.17898V1.79269C8.07803 0.804996 8.86903 0 9.85602 0H12.222Z"
        fill="#605DAF"
      />
    </svg>
  );
};
